export default __webpack_public_path__ + "static/media/fullscreen-exit.f687c3a9.svg";